/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';

interface CioModalConfirmSaveSignature {
  Args: {
    isDisabled: boolean;
    onClose: () => unknown;
    onConfirm: Task<unknown, []>;
  };
  Element: HTMLDivElement;
}

export default class CioModalConfirmSaveWaitUntilAction extends Component<CioModalConfirmSaveSignature> {}
